<template>
  <div class="dd-section">
    <div class="dd-section__title">
      {{title}}
    </div>
    <div class="dd-section__body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style lang="scss">
.dd-section {
  @extend %wrap;
  padding: 100px 20px 120px;
  color: #fff;

  &__title {
    font-size: 27px;
  }
  &__body {
    margin-top: 60px;
  }
  @include media-tablet {
    padding: 36px;

    &__title {
      font-size: 16px;
    }
    &__body {
      margin-top: 28px;
    }
  }
}
</style>
